NtechApp.Ajax = function() {
    var me = this;

    this._css = {
        ids: {},
        classes: {}
    };

    this._textLoadingNextStepTimeout = null;

    this._construct = function () {
        me._bindEvents();
    };

    this._bindEvents = function () {
    };

    this._unbindEvents = function () {
        ;
    };

    this.destruct = function () {
        me._unbindEvents();
    };

    this._construct();
    return this;
};

NtechApp.Ajax.RESPONSE_TYPES = {SUCCESS: "success", ERROR: "error"};
NtechApp.Ajax.REQUEST_TYPES = {POST: "POST", GET: "GET"};

NtechApp.Ajax.prototype.enableTextLoading = function($item, useVal) {
    var me = this;
    var useVal = useVal || false;

    var nextPoints = function(text) {
        var dot1 = text[text.length - 3];
        var dot2 = text[text.length - 2];
        var dot3 = text[text.length - 1];

        if(dot1 == "." && dot2 == "." && dot3 == ".")
            return ".";
        else if(dot2 == "." && dot3 == ".")
            return "...";
        else
            return ".."
    };

    var text = $item.text();
    var execStep = function() {
        if($item.length == 0 || $item.hasClass("stopAjaxTextLoading")) return;
        if(!useVal)
            $item.text(text + nextPoints($item.text()));
        else 
            $item.val(text + nextPoints($item.val()));

        me._textLoadingNextStepTimeout = setTimeout(execStep, 400);
    };

    if(!useVal)
        $item.text(text + nextPoints(text));
    else 
        $item.val(text + nextPoints(text));
    me._textLoadingNextStepTimeout = setTimeout(execStep, 400);
};

NtechApp.Ajax.prototype.disableTextLoading = function($item, useVal) {
    var useVal = useVal || false;
    clearTimeout(this._textLoadingNextStepTimeout);
    if(!useVal)
        $item.text($item.text().replace(/\./gi, ""));
    else 
        $item.val($item.text().replace(/\./gi, ""));
};

// @todo -> Refactor hasOwnProperty -> NtechApp.Dom.hasOwnProp
// @todo -> Refactor onSuccess, onComplete, onError -> ok, complete, error
// @todo -> Refactor constructors? (Move to subfuncs)
NtechApp.Ajax.prototype.post = function(requestParams) {
    var url = requestParams.url;
    var requestType = NtechApp.Ajax.REQUEST_TYPES.POST;
    var postData = (requestParams.hasOwnProperty("data")) ? requestParams.data : "";
    var onSuccess = (requestParams.hasOwnProperty("onSuccess")) ? requestParams.onSuccess : function() {};
    var onError = (requestParams.hasOwnProperty("onError")) ? requestParams.onError : false;
    var onComplete = (requestParams.hasOwnProperty("onComplete")) ? requestParams.onComplete : false;

    this._execute(url, requestType, postData, onSuccess, onError, onComplete);
};

NtechApp.Ajax.prototype.get = function(requestParams) {
    var url = requestParams.url;
    var requestType = NtechApp.Ajax.REQUEST_TYPES.GET;
    var getData = (requestParams.hasOwnProperty("data")) ? requestParams.data : "";
    var onSuccess = (requestParams.hasOwnProperty("onSuccess")) ? requestParams.onSuccess : function() {};
    var onError = (requestParams.hasOwnProperty("onError")) ? requestParams.onError : false;
    var onComplete = (requestParams.hasOwnProperty("onComplete")) ? requestParams.onComplete : false;

    this._execute(url, requestType, getData, onSuccess, onError, onComplete);
};

NtechApp.Ajax.prototype._execute = function(url, requestType, requestData, onSuccess, onError, onComplete) {
    var me = this;

    $.ajax({
        url: url,
        dataType: "json",
        type: requestType,
        context: this,
        data: requestData,

        success: function(response) {
            if(onComplete && typeof onComplete == "function")
                onComplete();

            if(response.status == NtechApp.Ajax.RESPONSE_TYPES.SUCCESS)
                onSuccess(response.data);
            else if(response.status == NtechApp.Ajax.RESPONSE_TYPES.ERROR) {
                if(onError && typeof onError == "function")
                    onError(response.errors);
                else {
                    NtechApp.Ajax.onError(response.errors);
                }
            }
        },

        error: function(jqXHR, textStatus) {
            //if(NtechApp.isDev)
            console.log("Ajax POST/GET request failed. Error text: " + textStatus);
        }
    });
};

NtechApp.Ajax.onError = function(errors) {
    var defErrorMessage = "Ajax request failed at backend.\n";
    var errorMessage = "Please fix following errors:\n";
    var hasErrors = false;

    for(errorName in errors) {
        hasErrors = true;
        var errorValue = errors[errorName];
        errorMessage += errorName + ": " + errorValue + "\n";
    }
    //var errorMessage  = "Server responded with 'error' status to Ajax request, ";
    //errorMessage     += "but no 'onError' callback handler was passed to request.";
    if(hasErrors)
        alert(errorMessage);
    else
        alert(defErrorMessage);
};